export default __webpack_public_path__ + "static/media/logo.38ce6a4c.svg";